import { render, staticRenderFns } from "./DePrivacyPolicy.vue?vue&type=template&id=67e5648c&scoped=true"
import script from "./DePrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./DePrivacyPolicy.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "67e5648c",
  null
  ,true
)

export default component.exports